var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGreenElectricityDefault = function SvgGreenElectricityDefault(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.71 198.48",
    height: 40,
    "aria-labelledby": titleId,
    ref: ref
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "green-electricity-title"
  }, "Green Electricity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "green-electricity-title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "green-electricity-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h204.71v198.48H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#green-electricity-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.15 48.42a35.76 35.76 0 0 1 4.8-17.92L94.09 1.72a12.85 12.85 0 0 0-12.85 0L6.43 44.91A12.86 12.86 0 0 0 0 56v86.39a12.85 12.85 0 0 0 6.43 11.13l74.81 43.19a12.85 12.85 0 0 0 12.85 0l74.81-43.19a12.85 12.85 0 0 0 6.43-11.13v-58h-.19a36 36 0 0 1-36-36",
    fill: "#93d319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.5 121.72c13.94-13.94 17.21-59.78 17.21-59.78s-9.47 4.93-24.58 6.23c-14.26 1.22-27.46 3.24-35.2 11C55 91.09 52 108.09 58.79 120.1 66.27 108.36 97 91.61 97 91.61c-22.08 15.79-33.33 28-48.48 49.62l7.43 2s5.53-10 10.34-14.81c12.07 8.56 30.47 6 43.18-6.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.14 18.86a29.57 29.57 0 1 0 29.57 29.57 29.57 29.57 0 0 0-29.57-29.57m11.67 32.82h-5.16a3.25 3.25 0 0 0-3.26 3.26v5.16a3.255 3.255 0 1 1-6.51 0v-5.17a3.25 3.25 0 0 0-3.26-3.26h-5.16a3.255 3.255 0 0 1 0-6.51h5.16a3.25 3.25 0 0 0 3.26-3.26v-5.15a3.255 3.255 0 0 1 6.51 0v5.16a3.25 3.25 0 0 0 3.26 3.26h5.16a3.255 3.255 0 0 1 0 6.51",
    fill: "#51a426"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGreenElectricityDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "green-electricity-default.f96e2a9a29ef9c84081f431525e207dc.svg";